import { render, staticRenderFns } from "./Chameleon.vue?vue&type=template&id=207f90e4&lang=pug&"
import script from "./Chameleon.vue?vue&type=script&lang=js&"
export * from "./Chameleon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports